/**
 * Visibilité d'une modale automatique pendant l'onboarding.
 * L'état "en attente" reste vrai : seul l'affichage est suspendu tant qu'un tour est actif,
 * pour que la modale réapparaisse dès que le tour se termine ou est quitté.
 */
export function isAutomaticModalVisible(isPending: boolean, isTourActive: boolean): boolean {
  return isPending && !isTourActive
}
